import {dataUpload} from "../../../common/upload";

export const saveDownloadedFile = (blob, fileName, params) => (dispatch, getState) => {
    blob.name = fileName
    dataUpload(`/api/download_history`, blob, null, null, {
        params: JSON.stringify(params ? params : {}),
        source: "attachment"
    }, false)(dispatch, getState)
}